import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('@/assets/icons/markers/marker-icon-2x-red.png'),
  iconUrl: require('@/assets/icons/markers/marker-icon-red.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
